import { render, staticRenderFns } from "./PageCategory.vue?vue&type=template&id=0987804c&"
import script from "./PageCategory.vue?vue&type=script&lang=js&"
export * from "./PageCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports